export { default as DocumentType } from "./DocumentType";
export { default as PreUploadIDCard } from "./PreUploadIDCard";
export { default as UploadIDCard } from "./UploadIDCard";
export { default as Name } from "./Name";
export { default as Sex } from "./Sex";
export { default as Birthday } from "./Birthday";
export { default as Nationality } from "./Nationality";
export { default as DocumentNumber } from "./DocumentNumber";
export { default as PlaceOfResidence } from "./PlaceOfResidence";
export { default as MainlandBankCard } from "./MainlandBankCard";
export { default as Policies } from "./Policies";

export { default as PreloadedStaticImg } from "./PreloadedStaticImg";
export { default as TaxResidence } from "./TaxResident";
export { default as SurveyHeaderProgressBar } from "./SurveyHeaderProgressBar";
